export const LOAN_CONTRACT_PDF = "loan-contract.pdf"
export const DEPOSIT_AGREEMENT_PDF = "deposit-agreement.pdf"
export const REPORT_PDF = "report.pdf"
